export enum LocalStorage {
  Profile = 'profile',
  SegmentAnonymousId = 'ajs_anonymous_id',
  ParkplusStoreV2Cart = 'parkplus_store_v2_user_cart',
  PreSelectedAddress = 'pre_selected_address',
  Theme = 'theme',
  DODUserNotified = 'dod_user_notified',
  DODhasVisited = 'dod_has_visited',
  SessionTracker = 'session_tracker',
  CreditLineReduxState = 'creditLineReduxState',
  Language = 'language',
  UserLocations = 'userLocations',
  UserProjectId = 'userProjectId',
  FuelBlastLoadingShown = 'fuel_blast_loading_shown',
  Ppl2025OnboardingShown = 'ppl_2025_onboarding_shown',
  Ppl2025ViewRewardMatchList = 'ppl_2025_view_reward_match_list',
  CoverageInfoTooltipShownDate = 'coverage_info_tooltip_shown_date',
  CarLoanCarnivalNotifiedClick = 'car_loan_carnival_notified_clicked',
  CarLoanJanuaryNotifiedClick = 'car_loan_jan_notified_clicked',
  CarLoanNavratriLeadFilled = 'car_loan_diwali_lead_filled',
  CarLoanJanuaryLeadFilled = 'car_loan_jan_lead_filled',
  BrowserFingerprint = 'pp_browser_fp',
  CarWashCouponPopupShownDate = 'car_wash_coupon_popup_shown_date',
}

export enum SessionStorage {
  InitialPagePath = 'source_initial_page_route',
  InitialPageFullPath = 'source_initial_page_full_route',
  MallParkingFirstTimeAnimation = 'mall_parking_first_time_animation',
  State = 'state',
  City = 'city',

  MediaUrl = 'mediaUrl',
  ActiveBackBtnClass = 'activeBackBtnClass',
  MoengageQueuedEvents = 'MoengageQueuedEvents',
  EmsQueuedEvents = 'EmsQueuedEvents',
  TrackingSessionId = 'user_session_id',
  nativeLocStatus = 'native_loc_status',
  nativeLocLatKey = 'native_loc_lat',
  nativeLocLngKey = 'native_loc_lng',
  ActiveModalIdentifiers = 'active_modal_identifiers',
  AppRatingEventSent = 'app_rating_event_sent',
  IsNewAddress = 'isNewAddress',
  AnimatedOrderIds = 'animated_order_ids',
  NativeContactListStatus = 'native_contact_list_status',
  NativeContactListChunkCount = 'native_contact_list_chunk_count',
  NativeContactListChunkIdx = 'native_contact_list_{{chunk_idx}}',
  NativeContactDataChunkCount = 'native_contact_list_chunk_count',
  UserContactList = 'user_contact_list',
  DonationLandingPageData = 'donation_landing_page',
  NativeContactPermissionModalShown = 'Native_contact_permission_modal_shown',
  ioclOrderConfirmationRewardShown = 'iocl_oc_reward_shown',
  ScannedTagData = 'scanned_tag_data',
  FuelFridayPopup = 'fuel_friday_popup',
  BBPSHomePageData = 'bbps_home_page_data',
  utmSource = 'utmSource',
  utmCampaign = 'utmCampaign',
  utmContent = 'utmContent',
  utmTerm = 'utmTerm',
  adGroupId = 'adgroupid',
  utmMedium = 'utmMedium',
  BBPSSavingDetails = 'bbps_saving_details',
  EarnPageScrollPosition = 'earn_page_scroll_position',
  BBPSDueBillsData = 'bbps_due_bills_data',
  Ppl2025JoinLeaguePopupShown = 'ppl_2025_join_league_popup_shown',
  Ppl2025ExitPopupShown = 'ppl_2025_exit_popup_shown',
  Ppl2025NotificationPopupShown = 'ppl_2025_notification_popup_shown',
  ROPopupShown = 'ro_popup_shown',
  PdiExitPopupShown = 'pdi_exit_popup_shown',
  CompareCarsData = 'compare_cars_data',
  adCampaignid = 'adCampaignid',
  adSource = 'adSource',
  braid = 'braid',
  clid = 'clid',
  XAssistedUserDetails = 'x-assisted-user-details',
  SellCarCarnivalConfirmPopupShown = 'sell_car_carnival_confirm_popup_shown',
  VoucherSelectedCategory = 'voucher_selected_category',
  ValetBookingOriginBrowser = 'valet_booking_origin_browser',
  CarWashCleanerId = 'carWashCleanerId',
  CarWashPromoCode = 'carWashPromoCode',
  CarWashGuestVehicle = 'carWashGuestVehicle',
}

export enum Cookies {
  VersionName = 'version-name',
  OsVersion = 'os-version',
  DeviceId = 'device-id',
  Lat = 'lat',
  Lng = 'lng',
  City = 'city-name',
  State = 'state-name',
  UpiMethods = 'upiMethods',
  FastagAdditionalData = 'fastagAdditionalData',
  ThirdPartyPartnerId = 'thirdPartyPartnerId',
  RefererSource = 'referer_source',
  AppOrigin = 'app_origin',
  PrimarySource = 'primary_source',
  WebviewPlatform = 'webview_platform',
  AuthPhoneNo = 'authPhoneNumber',
  InitialPagePath = 'source_initial_page_route',
  Pincode = 'pincode',
  Theme = 'setting-theme',
  AppLaunchCount = 'app-launch-count',
  VersionCode = 'version-code',
  AppsflyerId = 'appsflyer-id',
  AccessToken = 'access-token',
  RefreshToken = 'refresh-token',
  PaddingTop = 'padding_top',
  PaddingBottom = 'padding_bottom',
  InitialPageFullPath = 'source_initial_page_full_route',
  Platform = 'platform',
  DeviceBrand = 'device-brand',
  DeviceName = 'device-name',
  DeviceModel = 'device-model',
  DeviceRam = 'device-ram',
  OsName = 'os-name',
  PackageName = 'package-name',
  FpUniqueId = 'fp-unique-id',
  FpRequestId = 'fp-request-id',
}
